import * as _ from 'underscore';

import { Messages } from '../../codegen/Localize';
import { IDataSourceDetailInfo, NlpSetting } from '../models/IDataSourceInfo';
import { Module } from '../Module';
import { DataSources } from '../resources/Datasources';
import { IResult } from '../ServerApi/types/IResponse';
import { ToasterService, ToastType } from '../services/ToasterService';


export interface DataSourceNlpSettingEditorControls {
  enterEditMode: () => void;
  exitEditMode: () => void;
  save: ($event: JQueryEventObject) => void;
}

export interface DataSourceNlpSettingEditorState {
  canEdit: boolean;
  isBusy: boolean;
  isEditMode: boolean;
  isDirty: () => boolean;
}

export interface DataSourceNlpSettingValue {
  isEnable: boolean;
  analysisOption: NlpSetting;
  displayText: string;
}

export interface DataSourceNlpSettingEditorScope extends ng.IScope {
  datasource: IDataSourceDetailInfo;
  canSetNlpSetting: boolean;
  controls: DataSourceNlpSettingEditorControls;
  onSave: ($event: JQueryEventObject) => void;
  state: DataSourceNlpSettingEditorState;
  master: DataSourceNlpSettingValue;
  model: DataSourceNlpSettingValue ;
}

Module.instance().directive('tbDataSourceNlpSettingEditor', [
  'ToasterService',
  'DataSources',
  (toaster: ToasterService,
   dataSource: DataSources) => {
    return {
      restrict: 'A',
      replace: true,
      templateUrl: 'dataSourceNlpSettingEditor.html',
      scope: {
        datasource: '<',
        canSetNlpSetting: '<',
        onSave: '<',
      },
      link: (scope: DataSourceNlpSettingEditorScope) => {

        // initialize the UI state
        scope.state = {
          canEdit:    scope.canSetNlpSetting,
          isBusy:     false,
          isEditMode: false,
          isDirty:    () => _.isEqual(scope.master, scope.model)
        };

        scope.model = {
          isEnable: scope.datasource.nlpSetting !== NlpSetting.disabled,
          analysisOption: (scope.datasource.nlpSetting === NlpSetting.disabled) ? NlpSetting.enabled : scope.datasource.nlpSetting,
          displayText: '',
        };

        switch(scope.datasource.nlpSetting) {
          case NlpSetting.enabled:
            scope.model.displayText = Messages.dataSourceNlpSetting_enabled();
            break;
          case NlpSetting.disabled:
            scope.model.displayText = Messages.dataSourceNlpSetting_disabled();
            break;
          case NlpSetting.disableIndex:
            scope.model.displayText = Messages.dataSourceNlpSetting_indexDisabled();
            break;
          case NlpSetting.refresh24Hrs:
            scope.model.displayText = Messages.dataSourceNlpSetting_timedRefresh();
            break;
        }

        // controls for user actions
        scope.controls = {
          enterEditMode: () => {
            scope.state.isEditMode = true;
            scope.master = _.clone(scope.model);
          },
          exitEditMode: () => {
            scope.state.isEditMode = false;
            scope.model = scope.master;
          },
          save: ($event: JQueryEventObject) => {
            scope.state.isBusy = true;
            const params = {
              id: scope.datasource.id,
              nlpOption: (scope.model.isEnable) ? scope.model.analysisOption : NlpSetting.disabled
            };
            dataSource.setNlpSetting(params).then((result: IResult) => {
              if (!!result.errors) { // unexpected server error
                toaster.pop({ type: ToastType.Error, text: Messages.dataSourceNlpSetting_failed() });
              } else { // successful setCertification
                toaster.pop({ type: ToastType.Info, text: Messages.dataSourceNlpSetting_success() });
                scope.state.isEditMode = false;
                scope.onSave($event);
              }
              scope.state.isBusy = false;
            });
          }
        };
      }
    };
  }
]);
